export default "__VITE_ASSET__Qhhrro9___"